module.exports = __webpack_public_path__ + "ionicons.dd4781d1acc57ba4c480.ttf";


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/assets/fonts/ionicons.ttf?v=2.0.1
// module id = ../../../../../src/assets/fonts/ionicons.ttf?v=2.0.1
// module chunks = styles